import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';

const apiPrefix = window.location.hostname === 'localhost' ? '' : '/api';

export const useAlerts = () => useQuery({
    queryKey: ['alerts'],
    queryFn: () => axios.get(`${apiPrefix}/readAllAlerts`, { withCredentials: true }).then(r => r.data),
});

export const useUpdateAlert = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (data) => axios.put(`${apiPrefix}/updateAlert`, data, { withCredentials: true }).then(r => r.data),
        onSuccess: () => queryClient.invalidateQueries({ queryKey: ['alerts'] }),
    });
};

export const useCreateAlert = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (data) => axios.post(`${apiPrefix}/createAlert`, data, { withCredentials: true }).then(r => r.data),
        onSuccess: () => queryClient.invalidateQueries({ queryKey: ['alerts'] }),
    });
};

export const useUpdateAlertFull = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (data) => axios.post(`${apiPrefix}/updateAlertFull`, data, { withCredentials: true }).then(r => r.data),
        onSuccess: () => queryClient.invalidateQueries({ queryKey: ['alerts'] }),
    });
};
